module.exports = __webpack_public_path__ + "static/media/comp-mob1.42d31f3a.png";